var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-calendar',_vm._b({attrs:{"formatter":_vm.formatCalendar,"show-confirm":false,"title":_vm.title,"default-date":_vm.defaultDate,"min-date":_vm.minDate},on:{"confirm":_vm.handleConfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},'van-calendar',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }